import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Showupload from "./components/Showupload";
import Editupload from "./components/Editupload";
import Videos from "./components/Videos";
import { Route, Routes, Navigate } from "react-router-dom";

export const useAuth = {
  auth: false,
  login: function (callback) {
    this.auth = true;
    callback();
  },
};
function ProtectedRoute() {
  return <>{useAuth.auth ? <Dashboard /> : <Navigate replace to="/" />}</>;
}
function App() {
  return (
    <>
      <Routes>
        <Route index path="/" element={<Login />} />
        <Route path="dashboard" element={<ProtectedRoute />}>
          <Route index element={<Showupload />} />
          <Route path="editing" element={<Editupload />} />
          <Route path="video" element={<Videos />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
